/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SalesManager
 */
export interface SalesManager {
    /**
     * 
     * @type {string}
     * @memberof SalesManager
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof SalesManager
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesManager
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesManager
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof SalesManager
     */
    photo?: string;
}

/**
 * Check if a given object implements the SalesManager interface.
 */
export function instanceOfSalesManager(value: object): value is SalesManager {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    return true;
}

export function SalesManagerFromJSON(json: any): SalesManager {
    return SalesManagerFromJSONTyped(json, false);
}

export function SalesManagerFromJSONTyped(json: any, ignoreDiscriminator: boolean): SalesManager {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
        'lastName': json['lastName'] == null ? undefined : json['lastName'],
        'email': json['email'],
        'photo': json['photo'] == null ? undefined : json['photo'],
    };
}

export function SalesManagerToJSON(value?: SalesManager | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'email': value['email'],
        'photo': value['photo'],
    };
}

